import React, { useState, useEffect } from 'react'
import styles from './GeoHeader.module.scss'
import getVectorImage from '../../../utils/getVectorImage'
import { useGeoFetch, useGeoState } from '../../../components/GeoProvider'
import dayjs from 'dayjs'
import typeDisplayOptions from '../../Dashboard/typeDisplayOptions'
import SelectList from '../../../components/SelectList'
import DefaultBreadcrumbs from '../../../components/Breadcrumbs/DefaultBreadcrumbsPharma'
import DisplayDateAllergies from '../../../components/DisplayDateFlu/DisplayDateAllergies'
import MapOptionsAllergies from '../../../components/MapOptionsAllergies'
import regionDisplayOptions from '../regionDisplayOptions'
import diseaseDisplayOptions from '../diseaseDisplayOptions'
import { lastDisplayDate } from '../dates'
import toFixed from '../../../utils/toFixed'
const HeaderDisplay = ({ headerType, geo_id }) => {
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getgeoid, setgeoid] = useState('')
  const [getistrue, setistrue] = useState('')
  const [getDatavalue, setDatavalue] = useState('')
  const [getstatename, setStatename] = useState('')
  const [getPercentage, setPercentage] = useState('')
  const { setLocationName,diseaseSelected } = useGeoState()
  const { data: headerdata, error: stateDataError } = useGeoFetch(
    lastDisplayDate,
    lastDisplayDate,
    'allergiesheader',
    `${geo_id}/${diseaseSelected}`
  )

  useEffect(() => {
    if (headerdata !== null && headerdata !== undefined) {
      if (headerdata.response_code === 200) {
        setgeoid(headerdata.response_data.geo_id)
        setistrue(headerdata.response_data.istrue)
        setPercentage(headerdata.response_data.percentage)
        setDatavalue(headerdata.response_data.data_value)
        setStatename(headerdata.response_data.statename)
        headerType === 'ZIP3' &&
          setLocationName(headerdata.response_data.statename)
      } else {
        setErrorSubject(headerdata.response_subject)
        seterrorOccured(true)
      }
    }
  }, [headerdata])

  if (stateDataError || (errorOccured && errorSubject !== undefined)) {
    return <div>Unable to get the data for header {errorSubject}</div>
  }

  return (
    <>
      <div
        className={
          headerType === 'NAT'
            ? styles.natDiv
            : headerType === 'STATE'
            ? styles.stateDiv
            : styles.geoDiv
        }
      >
        <span className={styles.firstSpan}>
          {headerType !== 'STATE' && headerType !== 'NAT'
            ? getstatename
            : getgeoid}
        </span>
        <span className={styles.secondSpan}>{getVectorImage(getistrue)}</span>
        <span
          className={getistrue ? styles.stdatavalueup : styles.datavaluedown}
        >
          {' '}
          {toFixed(getPercentage,2)}%{' '}
        </span>
        <span className={styles.forthSpan}>
          {' '}
          ({getDatavalue})
          {headerType !== 'NAT' && headerType !== 'STATE' ? (
            <span className={styles.sinceWeek}> since last week</span>
          ) : (
            ''
          )}
        </span>
      </div>
    </>
  )
}

const Header = ({ headerType, headerNumber, geo_id }) => {
  const { locationName,setDiseaseSelected } = useGeoState()
  const [activeZip3, setactiveZip3] = useState()
  setDiseaseSelected(window.localStorage.getItem('disease'))
  const { data: activeZip3Data, error: activeZip3DataError } = useGeoFetch(
    '',
    '',
    'search',
    'locations/ALLERGIES',
    '',
    {
      'geo_type' : 'ZIP3'
    }
  )

  useEffect(() => {
    if (activeZip3Data !== null && activeZip3Data !== undefined) {
      setactiveZip3(activeZip3Data)
    }
  }, [activeZip3Data])
  return (
    <>
      <div className={styles.pageHeader}>
        <div className={styles.pageHeaderText}>
          <DefaultBreadcrumbs
            geo_parent={headerType}
            geo_id={geo_id}
            geo_type={'MSA'}
            dashboardType={'Allergies'}
          />
          <SelectList
            dropdownData={typeDisplayOptions}
            defaultValue={'allergies'}
            defaultLabel={'Allergies and Air Quality'}
          />
          <div style={{marginTop:'-30px',fontSize:'14px'}}>
          <DisplayDateAllergies
                    showWeek={true}
                    diseaseType={'Allergies'}
                    location_name={locationName}
                  />
            </div>
        </div>
        {/* <div className={styles.geoName}>{locationName}</div> */}
        <div className={styles.pageHeaderRight}>
          <div className={styles.pageHeaderTextValue}>
            <HeaderDisplay headerType={'NAT'} geo_id={'NAT'}></HeaderDisplay>
            <HeaderDisplay
              headerType={'STATE'}
              geo_id={headerType}
            ></HeaderDisplay>
            <HeaderDisplay headerType={'ZIP3'} geo_id={geo_id}></HeaderDisplay>
            
          </div>
          <div>
          <MapOptionsAllergies 
              regionDisplayOptions={regionDisplayOptions} 
              diseaseDisplayOptions={diseaseDisplayOptions}
              activeZip3={activeZip3} 
              entity={'Allergies'}
              geo_type={headerType}
          /> 
          </div>
        </div>
      </div>
    </>
  )
}
export default Header
